module.exports = __webpack_public_path__ + "static/media/third-img.cf7a926d.jpg";